<template>
  <div class="empadronamiento__intro__main__form__container-file">
    <button
      @click="openUpload"
      class="empadronamiento__intro__main__form__file"
      :class="{ 'has-error': invalid }"
    >
      <!-- Preview -->
      <img
        v-if="
          !preview &&
            state != 0 &&
            previewURL &&
            previewURL != '' &&
            previewURLLoaded
        "
        :src="previewURL"
        ref="preview"
        class="preview"
      />
      <img
        v-if="preview && preview.indexOf('image/') > 0"
        :src="preview"
        ref="preview"
        class="preview"
      />
      <img
        v-if="preview && preview.indexOf('image/') == -1"
        ref="preview"
        alt
        class="preview--loaded"
      />
      <img
        v-if="
          !preview &&
            state != 0 &&
            previewURL &&
            previewURL != '' &&
            !previewURLLoaded
        "
        ref="preview"
        alt
        class="preview--loaded"
      />
      <img
        v-if="!preview && (!previewURL || state == 0)"
        ref="preview"
        alt
        class="preview"
      />
      <!-- /Preview -->
      <p>{{ attach.Name }}</p>
      <!-- Iconos -->
      <img v-if="state == 0" class="file" src="@/img/get_app-24px.svg" alt />
      <div v-else @click.stop.capture="handleClearUpload" style="z-index: 999;">
        X
      </div>
      <!-- /Iconos -->
      <input
        type="file"
        @change="handleEmitUpload"
        ref="input"
        :accept="accept"
        style="display:none"
      />
    </button>

    <div class="empadronamiento__intro__main__form__tooltip-file">
      <div
        class="icon"
        @click="$emit('changeTooltipActive', attach.Code)"
        v-if="existTooltip()"
      >
        ?
      </div>
      <div v-else class="empty-icon"></div>
      <div
        class="text"
        v-if="showTooltipActive == attach.Code"
        v-html="getTextTooltip()"
      ></div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    attach: Object,
    invalid: Boolean,
    modelProp: String,
    showTooltipActive: String,
    accept: {
      type: String,
      default: "image/*,.pdf",
    },
    state: [Object, String, Number],
    previewURL: {
      type: String,
      default: "",
    },
    keyIndex: [Number],
  },
  data() {
    return {
      preview: "",
      previewURLLoaded: false,
      showTooltip: false,
    };
  },
  computed: {
    ...mapState({
      Enums: (state) => state.neighregistration.Enums,
    }),
  },
  created() {
    var img = new Image();
    img.src = this.previewURL;
    img.onload = () => (this.previewURLLoaded = true);
    img.onerror = () => (this.previewURLLoaded = false);
  },
  methods: {
    openUpload() {
      if (this.state === 0 || this.state === null) this.$refs.input.click();
    },

    handleEmitUpload($event) {
      this.loadPreview($event.target.files[0]);
      this.$emit("change", {
        file: $event.target.files[0],
        attach: this.attach,
        attachmentTypeId: this.attach.Id,
        modelProp: this.modelProp,
        keyIndex: this.keyIndex,
      });
    },

    loadPreview(file) {
      const reader = new FileReader();
      const self = this;

      reader.onload = function(e) {
        self.preview = e.target.result;
      };
      reader.readAsDataURL(file);
    },

    handleClearUpload() {
      this.$emit("clearUpload", {
        modelProp: this.modelProp,
        keyIndex: this.keyIndex,
      });
      this.preview = "";
    },

    getTextTooltip() {
      const tooltip = this.Enums.ProcedureAttachmentTooltipDescription.filter(
        (tooltip) => tooltip.Code.includes(this.attach.Code)
      );
      return tooltip[0].Description;
    },

    existTooltip() {
      const tooltip = this.Enums.ProcedureAttachmentTooltipDescription.filter(
        (tooltip) => tooltip.Code.includes(this.attach.Code)
      );
      return tooltip.length != 0;
    },
  },
};
// TODO: catch errores al hacer upload fallido en todos los - uploadFile() -
</script>
